<template>
  <v-app>
    <!-- <v-app style="background-color: #f1f1f1">-->
    <v-app-bar app color="primary" dense dark v-if="false">
      <div class="d-flex align-center">
        <router-link to="/" style="color: white">{{ $route.meta.title || 'Ernest' }}</router-link>
      </div>

      <v-spacer></v-spacer>

      <v-btn target="_blank" icon @click="showMenu = !showMenu" v-if="$route.meta.hideMenu !== false">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer v-model="showMenu" temporary right app>
      <v-list dense nav>
        <!-- Web routes -->
        <div v-for="(routes, k) in routes2" :key="k">
          <v-subheader v-if="k" style="border-top: 1px solid #ddd; margin-top: 10px; padding-top: 0px">
            {{ k }}
          </v-subheader>
          <v-list-item v-for="(route, index) in routes" :key="index" link :to="route.to">
            <v-list-item-icon>
              <v-icon>{{ route.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ route.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
      <div style="height: 80px"></div>
    </v-navigation-drawer>

    <v-main>
      <v-container>
        <div v-if="false">
          <h1>{{ $route.meta.title || 'Ernest' }}</h1>
        </div>

        <div v-if="!$route.meta.hideMenu" style="position: fixed; top: 10px; right: 10px; z-index: 1000">
          <v-btn target="_blank" fab color="success" depressed small @click="showMenu = !showMenu">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </div>
        <transition :name="transitionName" mode="out-in">
          <router-view :key="$route.fullPath" style="min-height: 70vh; display: block" />
        </transition>
        <!-- On-screen log display -->
        <ConsoleLog v-if="username == 'kaixo' && false" :fixed="false" />
      </v-container>
    </v-main>
    <!-- bottom nav regalos test-->
    <v-bottom-navigation v-if="$route.path.startsWith('/regalos')" app fixed>
      <v-btn to="/">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn to="/regalos">
        <v-icon> {{ $route.path === '/regalos' ? 'mdi-gift' : 'mdi-gift-outline' }}</v-icon>
      </v-btn>

      <v-btn to="/regalos/open">
        <v-icon>
          {{ $route.path.startsWith('/regalos/open') ? 'mdi-cart' : 'mdi-cart-outline' }}
        </v-icon>
      </v-btn>

      <v-btn to="/regalos/purchased">
        <v-icon>
          {{ $route.path.startsWith('/regalos/purchased') ? 'mdi-calculator' : 'mdi-calculator' }}
        </v-icon>
      </v-btn>
    </v-bottom-navigation>

    <!-- bottom nav watchlist -->
    <v-bottom-navigation v-if="$route.path.startsWith('/watchlist')" app fixed>
      <v-btn to="/">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn to="/watchlist/">
        <v-icon :color="['/watchlist/', '/watchlist'].includes($route.path) ? 'primary' : 'rgb(108, 119, 120)'"
          >mdi-video-vintage</v-icon
        >
      </v-btn>

      <v-btn to="/watchlist/recommended" v-if="false">
        <v-icon :color="$route.path.startsWith('/watchlist/recommended') ? 'primary' : 'rgb(108, 119, 120)'"
          >mdi-share-variant</v-icon
        >
      </v-btn>

      <v-btn to="/watchlist/search">
        <v-icon :color="$route.path.startsWith('/watchlist/search') ? 'primary' : 'rgb(108, 119, 120)'"
          >mdi-magnify</v-icon
        >
      </v-btn>
    </v-bottom-navigation>

    <!-- bottom nav expenses -->
    <v-bottom-navigation v-if="$route.path.startsWith('/expenses')" app fixed>
      <v-btn to="/">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn to="/expenses/">
        <v-icon :color="['/expenses/', '/expenses'].includes($route.path) ? 'primary' : 'rgb(108, 119, 120)'"
          >mdi-currency-usd</v-icon
        >
      </v-btn>

      <v-btn to="/expenses/upload">
        <v-icon :color="$route.path.startsWith('/expenses/upload') ? 'primary' : 'rgb(108, 119, 120)'"
          >mdi-upload</v-icon
        >
      </v-btn>

      <v-btn to="/expenses/merged">
        <v-icon :color="$route.path.startsWith('/expenses/merged') ? 'primary' : 'rgb(108, 119, 120)'"
          >mdi-list-box</v-icon
        >
      </v-btn>
      <v-btn to="/expenses/coinbase-merged">
        <v-icon :color="$route.path.startsWith('/expenses/coinbase-merged') ? 'primary' : 'rgb(108, 119, 120)'"
          >mdi-currency-btc</v-icon
        >
      </v-btn>

      <v-btn v-if="false" to="/expenses/search">
        <v-icon :color="$route.path.startsWith('/expenses/search') ? 'primary' : 'rgb(108, 119, 120)'"
          >mdi-magnify</v-icon
        >
      </v-btn>
    </v-bottom-navigation>

    <!-- bottom nav menus -->
    <v-bottom-navigation v-if="$route.path.startsWith('/food')" app fixed>
      <v-btn to="/">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn to="/food/items">
        <v-icon>mdi-food</v-icon>
      </v-btn>
      <v-btn to="/food/menus">
        <v-icon>mdi-calendar</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-app>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import api from '@/assets/api'
import ConsoleLog from './components/ConsoleLog.vue'
//import PullToRefresh from '@/components/PullToRefresh.vue'

export default {
  name: 'App',
  components: {
    ConsoleLog,
    //PullToRefresh,
  },

  data() {
    return {
      showMenu: false,
      previousRoute: null,
    }
  },
  watch: {
    $route(to, from) {
      this.previousRoute = from.path
    },
  },
  computed: {
    ...mapGetters(['username']),
    ...mapState(['token']),
    transitionName() {
      if (this.$route.meta.transitionName) {
        return this.$route.meta.transitionName
      }

      if (!this.previousRoute) return 'fade'

      const currentDepth = this.$route.path.split('/').length
      const previousDepth = this.previousRoute.split('/').length

      //TODO: slide transition produces layout shifts as data loads while the transition happens. Better use just fade for now
      /* 
      console.log('currentDepth', currentDepth)
      console.log('previousDepth', previousDepth)

      if (currentDepth == 2) return 'fade'

      const diff = currentDepth - previousDepth
      console.log('diff', diff)
      if (diff > 0) return 'slide-right'
      if (diff < 0) return 'slide-left'
      */
      return 'fade'
    },
    routes() {
      return api.userAppRoutes()
    },
    routes2() {
      let rr = api.userAppRoutes()
      const x = {}

      for (let i = 0; i < rr.length; i++) {
        const r = rr[i]
        if (!x[r.shared]) x[r.shared] = []
        x[r.shared].push(r)
      }
      return x
    },
  },
  methods: {
    async handleRefresh() {
      // Forces reload from server, bypassing cache
      window.location.reload(true) // Note: true is deprecated in modern browsers

      // Better modern way:
      await navigator.serviceWorker?.ready // Wait if you have PWA
      window.location.reload()
    },
    async pingApi() {
      // honestly, this is just to
      // (1) ping the API so when we need it for real we have less cold start
      // (2) avoid frustration of expired token complaining later.
      let x = await api.apiFetch('/whoami')
      let j = await x.json()
      console.log('/whoami', j)
    },
  },
  mounted() {
    this.pingApi()
    // Initialize previous route
    this.previousRoute = this.$route.path

    //redirect to paraguas.pasalo.es ---
    let host = location.hostname
    if (host == 'pasaparaguas.netlify.app') {
      location.href = location.href.replace('pasaparaguas.netlify.app', 'paraguas.pasalo.es')
    }
    //end of redirect

    //sessionId ----

    //sessionId & refreshId can be used to get around caches while fetching data:
    //sessionId - lasts as long as the session storage:
    let x = sessionStorage.sessionId
    if (!x) sessionStorage.sessionId = new Date().getTime()

    //refreshId - changes with each refresh
    sessionStorage.refreshTime = new Date().getTime()
  },
}
</script>

<style>
a:hover {
  text-decoration: none;
}

/** css for transitions */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.3s ease;
}
.slide-right-enter {
  transform: translateX(100%);
}
.slide-right-leave-to {
  transform: translateX(-100%);
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.3s ease;
}
.slide-left-enter {
  transform: translateX(-100%);
}
.slide-left-leave-to {
  transform: translateX(100%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.none-enter-active,
.none-leave-active {
  transition: none;
}
.none-enter,
.none-leave-to {
  /* no transition effects */
  transition: none;
}

/*** for pull-to-refresh */
/* === CRITICAL FIXES FOR VUETIFY 2 + CUSTOM SCROLL === */
.custom-main {
  padding: 0 !important; /* Remove Vuetify's default padding */
}

.custom-main > .v-main__wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Ensure our pull-to-refresh wrapper fills everything */
pull-to-refresh {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
}

/* Ensure router-view content fills the scrollable area */
.page-content {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

/* Optional: If your route components use v-container, make it fluid */
.v-container.page-content {
  padding: 0;
  max-width: 100%;
}
/** end code for pull-to-refresh */
</style>
